import styles from '../styles/FullPageLoader.module.css';

const FullPageLoader = (props) => {
    const text = props?.text || "Loading...";
    return (
        <div className={styles.LoaderContainer}>
            <div className={styles.Spinner}></div>
            <p>{text}</p>
        </div>
    );
};

export default FullPageLoader;
